@if (items()) {
  @if (items().length > 0) {
    <app-compact-list
      [items]="items()"
      [columns]="columns"
      (itemSelected)="itemSelected($event)"
      (columnsUpdated)="columnsUpdated($event)">
    </app-compact-list>
  } @else {
    <app-feedback-text type="empty">
      <span translate>No vehicles to show</span>
    </app-feedback-text>
    <app-feedback-text type="information">
      <span translate>The selected garage is not registered in our source system TDS and the functionality is therefore limited</span>
    </app-feedback-text>
  }
} @else {
  <div class="py-4">
    <places-spinner [small]="true"></places-spinner>
  </div>
}


